import React from "react";
import { FiPlus } from "react-icons/fi";

const CreateUserButton = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            className="
                flex items-center gap-2
                bg-gradient-to-r from-indigo-600 to-purple-600
                hover:from-indigo-700 hover:to-purple-700
                text-white px-5 py-3 rounded-xl
                shadow-lg hover:shadow-xl
                transition-all duration-300
                font-medium
            "
        >
            <FiPlus size={20} />
            Create New User
        </button>
    );
};

export default CreateUserButton;